module.exports = __webpack_public_path__ + "img/default.2e9f2e54.svg";